import React from "react";
import { useField } from "formik";

const TextInput = ({ label, shouldShowError, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <div className="form-group col">
            {label && <label className={"capitalize text-sm"} htmlFor={props.id || props.name}>{label}</label>}
            <input className={"form-control"} {...field} {...props} />
            {shouldShowError || (meta.touched && meta.error) ? (
                <div className="text-danger">{meta.error}</div>
            ) : null}
        </div>
    );
};

export default TextInput;